export interface DefaultServiceResult {
    message: string;
}
